class SeedProjectGallery extends HTMLElement {
  connectedCallback() {
    this.groups = [...this.querySelectorAll('[data-project-gallery-group]')];
    this.groups.forEach((group) => this.setup(group));
  }

  setup(group) {
    const track = group.querySelector('[data-project-gallery-track]');
    const slides = [...group.querySelectorAll('[data-project-gallery-slide]')];
    if (!track || slides.length < 2) return;

    const visible = () => Math.max(1, Number(getComputedStyle(group).getPropertyValue('--seed-visible')) || 1);
    if (slides.length <= visible()) return;

    const clones = slides.slice(0, visible()).map((slide) => {
      const clone = slide.cloneNode(true);
      clone.setAttribute('aria-hidden', 'true');
      clone.removeAttribute('data-project-gallery-slide');
      clone.querySelectorAll('[id]').forEach((node) => node.removeAttribute('id'));
      track.append(clone);
      return clone;
    });

    let index = 0;
    let wrapping = false;
    const go = () => {
      if (document.hidden || wrapping) return;
      index += 1;
      if (index < slides.length) {
        track.scrollTo({ left: slides[index].offsetLeft - track.offsetLeft, behavior: 'smooth' });
        return;
      }
      wrapping = true;
      track.scrollTo({ left: clones[0].offsetLeft - track.offsetLeft, behavior: 'smooth' });
      window.setTimeout(() => {
        track.style.scrollBehavior = 'auto';
        track.scrollLeft = slides[0].offsetLeft - track.offsetLeft;
        index = 0;
        wrapping = false;
        requestAnimationFrame(() => track.style.removeProperty('scroll-behavior'));
      }, 850);
    };
    group._seedTimer = window.setInterval(go, 4000);
  }

  disconnectedCallback() {
    this.groups?.forEach((group) => window.clearInterval(group._seedTimer));
  }
}

if (!customElements.get('seed-project-gallery')) customElements.define('seed-project-gallery', SeedProjectGallery);
